import React, { useCallback, useState } from 'react';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Buttons } from 'lidya-common-components';
import { findImage } from '../../common/imageLoader';
import SignUpModal from '../../default/signUp/sign.up.modal';
import { POSSIBLE_FORMS } from '../../default/signUp/sign.up.memo.form';

const InvestAt = function () {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const toggleModal = useCallback(() => setShowModal(!showModal), [showModal]);

  return (
    <div className="o-investors">
      <div className="m-globalContentContainer">
        <div className="m-investors__container">
          <div className="m-investors__banner">
            <span className="m-investors__image">
              <GatsbyImage
                image={findImage('investors/Group_1')}
                alt={t('images.investors.group.alt')}
                title={t('images.investors.group.title')}
              />
            </span>
            <span className="m-investors__text --padding-right">
              <p className="m-investors__text__brand">
                <Trans i18nKey="web.investors.help.small" />
              </p>
              <SignUpModal
                id="Invest"
                type={Buttons.BUTTON_TYPES.PRIMARY}
                label="web.investors.invest.button"
                onClick={() => toggleModal()}
                signupType={POSSIBLE_FORMS.INVESTORS}
                className="m-investors__text__button"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestAt;
